import React, { useEffect, useState } from 'react';
import Select from 'react-select'; // Ensure you have installed react-select
import { dropDownsList, staticDropDownsList } from '../../services/api/user';
import { useLanguage } from '../LanguageProvider/LanguageProvider ';

const 
SelectType = ({ value, dropdownId, fieldKey, onChange, placeholder, styles, theme, ukStateId, fieldsDisabled = false }) => {
    const { language } = useLanguage();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const formData = new FormData();
                formData.append("dropdown_id", dropdownId);
                const response = await dropDownsList(formData);
                const ParsedDropdownValue = JSON.parse(response?.data?.dropdown_values);
                const formattedOptions = ParsedDropdownValue?.items?.map((option, index) => ({
                    value: String(option?.id ? option?.id : `${index + 1}`), // Concatenate id with index
                    label: {
                        en: option?.name_en,
                        hi: option?.name_hi
                    }
                }));
                setOptions(formattedOptions);

                if (!response?.data?.dropdown_values || response?.data?.dropdown_values == "null") {
                    const staticFormData = new FormData();
                    staticFormData.append("title", response?.data?.name_en.toLowerCase());
                    const staticList = await staticDropDownsList(staticFormData);
                    let formattedStaticOptions = [];
                    if(response?.data?.name_en.toLowerCase() === "district"){
                        formattedStaticOptions = staticList?.data.filter((d) => d.state_id === ukStateId)?.map(option => ({
                            value: String(option.id),
                            label: {
                                en: option?.name_en,
                                hi: option?.name_hi
                            }
                        }));
                    } else {
                        formattedStaticOptions = staticList?.data?.map(option => ({
                            value: String(option.id),
                            label: {
                                en: option?.name_en,
                                hi: option?.name_hi
                            }
                        }));
                    }
                    setOptions(formattedStaticOptions);
                }
            } catch (error) {
                //console.error("Error fetching dropdown options:", error);
            }
        };

        fetchOptions();
    }, [dropdownId, language]);

    const option = options?.find(option => {
        return String(option?.value) === String(value) || option?.label.en === String(value) || option?.label.hi === String(value);
    });

    return (
       <>
            {/* <div>{JSON.stringify(value)}</div> */}
            <Select
                components={{
                    IndicatorSeparator: () => null,
                }}
                styles={styles}
                theme={theme}
                options={options?.map((option) => ({
                    value: option?.value,
                    label: language ? option?.label?.hi : option?.label?.en, // Use Hindi or English label
                }))}
                placeholder={placeholder}
                value={option ? { value: option?.value, label : option?.label[language ? "hi" : "en"] } : null}
                onChange={(selectedOption) => {
                    onChange({ target: { value: selectedOption, name: fieldKey } });
                }}
                isDisabled={fieldsDisabled}
            />
       </>
    );
};

export default SelectType;
